<script>
  import { onMount } from 'svelte'
  let sliderPosition = 0;
  let previousSlide = 2;
  let carouselHeight;
  let partyDiv;
  let nextSlide = 1;
  let currentSlideActiveClass = "ENTREPRENEUR";
  let sliderItems = [
    {
      imgSrc:
        "https://movement-assets.imgix.net/media/caseycrawford.com/entrepreneur-new-img.jpg",
      heading: "ENTREPRENEUR",
      text:
        "Casey Crawford is the co-founder and CEO of Movement Mortgage, one of the leading retail mortgage lenders in the country and a six-time member of the Inc. 5000 list. The former Super Bowl champion also serves as chairman of Movement Bank and Movement Insurance.",
      logoSet: [
        { imgSrc: "/images/mm-logo.svg" },
        { imgSrc: "/images/mm-insurance.svg" },
        {
          imgSrc:
            "https://movement-assets.imgix.net/media/caseycrawford.com/mm-Bank-new-logo.svg",
        },
      ],
      cta: {
        text: "VISIT MOVEMENT MORTGAGE →",
        link: "https://movement.com",
      },
    },
    {
      imgSrc: "https://movement-assets.imgix.net/media/caseycrawford.com/leader-new-img.jpg",
      heading: "LEADER",
      text:
        "Casey Crawford has been recognized both domestically and around the world as a transformative leader. He is a recipient of the John C. Maxwell Transformational Leader Award, named Most Admired CEO by the Charlotte Business Journal and is an Ernst & Young Entrepreneur of the Year recipient.",
      logoSet: [
        { imgSrc: "/images/award-1.svg" },
        { imgSrc: "/images/award-2.svg" },
        { imgSrc: "/images/award-3.svg" },
      ],
      cta: {
        text: "READ MORE →",
        link: "https://movement.com/blog/search/Casey+Crawford/",
      },
    },
    {
      imgSrc: "/images/CATALYST.jpg",
      heading: "CATALYST",
      text:
        "Casey Crawford founded the Movement Foundation to carry out Movement Mortgage’s mission to love and value people by investing company profits in communities around the world. The foundation has helped build schools, health clinics and more.",
      logoSet: [
        { imgSrc: "/images/logo-foundation.svg" },
        { imgSrc: "/images/logo-school.svg" },
        { imgSrc: "/images/logo-wellness.svg" },
      ],
      cta: {
        text: " MOVEMENT MORTGAGE DONATES $200 MILLION →",
        link:
          "https://movement.com/blog/2020/01/31/movement-mortgage-donates-22-million-for-charter-school-expansion-in-charlotte/",
      },
    },
  ];
  function onNext() {
    if (sliderPosition == 2) {
      sliderPosition = 0;
    } else {
      sliderPosition++;
    }
    currentSlideActiveClass = sliderItems[sliderPosition].heading;
    changeSlide();
  }

  function onPrev() {
    if (sliderPosition == 0) {
      sliderPosition = 2;
    } else {
      sliderPosition--;
    }
    currentSlideActiveClass = sliderItems[sliderPosition].heading;
    changeSlide();
  }

  //changes the slide before and after the active one
  function changeSlide() {
    if (sliderPosition == 0) {
      previousSlide = 2;
    } else {
      previousSlide = sliderPosition - 1;
    }
    if (sliderPosition == 2) {
      nextSlide = 0;
    } else {
      nextSlide = sliderPosition + 1;
    }
  }

  onMount(function initializeCarousel() {
    var containerID = document.getElementById("carousel");
    containerID.addEventListener("touchstart", startTouch, false);
    containerID.addEventListener("touchmove", moveTouch, false);
  });

  // Swipe Up / Down / Left / Right
  var initialX = null;
  var initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  }

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }
    if (initialY === null) {
      return;
    }
    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;
    var diffX = initialX - currentX;
    var diffY = initialY - currentY;
    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 0) {
        // swiped left
        onNext();
      } else {
        // swiped right
        onPrev();
      }
    }
    initialX = null;
    initialY = null;
    e.preventDefault();
  }
</script>

<style>
  .container {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: 120px;
    margin-bottom: 150px;
  }
  .carousel {
    display: flex;
    width: 100%;
    /* overflow-x: hidden; */
    position: relative;
  }
  .slide {
    width: 30%;
    height: 320px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    position: relative;
    transition: 500ms ease-in-out;
    transition-property: background-image;
    margin-right: 3.4%;
    width: 21.1%;
    flex: 1 0 auto;
  }
  .slide:nth-child(1) {
    width: 5%;
    background-position: 100% 50%;
  }
  .slide:nth-child(2) {
    margin: 0 20px;
    /* width: auto; */
    height: inherit;
  }
  .slide:nth-child(3) {
    margin: 0 20px 0 0;
  }
  .slide:last-child {
    width: 10%;
    background-position: 0% 50%;
    margin: 0;
  }
  .slide.featured {
    width: 30%;
  }
  .greyed-out {
    background-color: rgba(255, 255, 255, 0.7);
    width: 100%;
    height: 100%;
  }
  .heading {
    font-family: 'Gotham A', 'Gotham B';
    font-style: normal;
    font-weight: 800;
    color: #ff2c2d;
    letter-spacing: 12px;
    padding: 12px;
  }
  .sub-container {
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    margin-bottom: 10px;
  }
  .logo {
    margin-left: 40px;
    margin-right: 40px;
  }
  .logo-container {
    display: flex;
    justify-content: center;
    width: 45vw;
  }
  .l-button {
    display: flex;
    margin: 2.25vw 0;
  }
  .l-button {
    display: flex;
    margin: 2.25vw 0;
  }
  button {
    all: unset;
    border: 1px solid black;
    width: 13%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  button:last-child {
    border-left: none;
  }
  section {
    position: relative;
  }
  .l-carousel {
    position: absolute;
    width: 100%;
  }
  .slide-container {
    display: flex;
    align-items: flex-start;
    transition: transform 0.5s ease-in-out;
  }
  .carousel-party-crasher {
    box-sizing: border-box;
    position: inherit;
    margin-left: 11.7%;
    width: 32.2%;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px 3%;
  }
  .casey-quality {
    font-size: 32px;
    font-weight: 800;
    color: #1b22251f;
    letter-spacing: 0.25em;
    margin-bottom: 1.5vw;
  }
  .active {
    color: #ff2c2d;
  }
  .l-more-info {
    /* overflow-x: hidden; */
    display: flex;
    position: relative;
  }
  .associated-logo {
    width: 45%;
  }
  .more-info-description {
    font-family: 'Gotham A', 'Gotham B';
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    font-size: 15px;
    width: 33vw;
  }
  .more-info-container {
    width: 50%;
    display: flex;
    flex-direction: row;
  }
  .more-info-link {
    color: #ff2c2d;
    font-size: 18px;
    font-family: 'Gotham A', 'Gotham B';
    font-style: normal;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 2px;
  }
  .mobile-slide {
    display: none;
  }
  .cta {
    width: 20%;
  }
  .link-container {
    width: 240px;
    margin-left: 25px;
  }
  @media only screen and (max-width: 1200px) and (min-width: 1025px) {
    .logo {
      margin-left: 25px;
      margin-right: 25px;
    }
  }
  @media only screen and (max-width: 1024px) {
    .carousel {
      height: 250px;
    }
    .casey-quality {
      font-size: 24px;
    }
    .slide {
      height: inherit;
    }
    .slide.featured {
      width: 320px;
    }
    .sub-container {
      display: flex;
      flex-direction: column;
      margin-top: 50px;
      margin-bottom: 10px;
      /* align-items: center; */
    }
    .more-info-container {
      margin-top: 50px;
      width: 100%;
      justify-content: space-evenly;
    }
    .more-info-description {
      width: 50%;
    }
    .logo-container {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .mobile-slide {
      display: none;
    }
  }
  @media only screen and (max-width: 720px) {
    .carousel {
      height: 200px;
    }
    .slide:nth-child(2) {
      display: none;
    }
    .slide:last-child {
      width: 5%;
    }
    .slide.featured {
      width: 70%;
    }
    .logo-container {
      justify-content: space-around;
      height: 13vw;
    }
    .logo {
      margin: 0;
      overflow: hidden;
    }
    .more-info-container {
      flex-direction: column;
      margin-left: 30px;
      margin-right: 30px;
      width: fit-content;
    }
    .more-info-description {
      width: 100%;
    }
    .mobile-slide {
      display: flex;
      justify-content: space-evenly;
      align-items: baseline;
      margin-bottom: 25px;
    }
    button {
      height: 35px;
      width: 35px;
    }
    .casey-quality {
      font-size: 16px;
      width: 50%;
    }
    .link-container {
      margin-top: 50px;
      margin-left: 0px;
    }
  }
</style>

<div class="container" style="height: {carouselHeight}px">
  <div class="mobile-slide">
    <div class:active={currentSlideActiveClass} class="casey-quality">
      {currentSlideActiveClass}
    </div>
    <div class="l-button">
      <button on:click={onPrev}>
        <img src="/images/prev-arrow.svg" alt="previous button" />
      </button>
      <button on:click={onNext}>
        <img src="/images/next-arrow.svg" alt="next button" />
      </button>
    </div>
  </div>
  <div id="carousel" class="carousel">
    <div
      class="slide"
      style={`background-image: url(${sliderItems[previousSlide].imgSrc})`}>
      <div class="greyed-out" />
    </div>
    <div
      class="slide"
      style="height: {carouselHeight}px"
      bind:offsetWidth={partyDiv}>
      <div
        class:active={currentSlideActiveClass === "ENTREPRENEUR"}
        class="casey-quality"
        style="font-size:{partyDiv / 13.5}px">
        ENTREPRENEUR
      </div>
      <div
        class:active={currentSlideActiveClass === "LEADER"}
        class="casey-quality"
        style="font-size:{partyDiv / 13.5}px">
        LEADER
      </div>
      <div
        class:active={currentSlideActiveClass === "CATALYST"}
        class="casey-quality"
        style="font-size:{partyDiv / 13.5}px">
        CATALYST
      </div>
      <div class="l-button">
        <button on:click={onPrev}>
          <img src="/images/prev-arrow.svg" alt="previous button" />
        </button>
        <button on:click={onNext}>
          <img src="/images/next-arrow.svg" alt="next button" />
        </button>
      </div>
    </div>
    <div
      id="carousel"
      class:active={currentSlideActiveClass === "ENTREPRENEUR"}
      class="slide featured"
      style={`background-image: url(${sliderItems[sliderPosition].imgSrc})`} />
    <div
      id="carousel"
      class="slide"
      style={`background-image: url(${sliderItems[nextSlide].imgSrc})`}>
      <div class="greyed-out" />
    </div>
  </div>
  <div class="sub-container">
    <div class="logo-container">
      <img
        class="logo"
        src={sliderItems[sliderPosition].logoSet[0].imgSrc}
        alt="placeholder" />
      <img
        class="logo"
        src={sliderItems[sliderPosition].logoSet[1].imgSrc}
        alt="placeholder" />
      <img
        class="logo"
        src={sliderItems[sliderPosition].logoSet[2].imgSrc}
        alt="placeholder" />
    </div>
    <div class="more-info-container">
      <span class="more-info-description">
        {sliderItems[sliderPosition].text}
      </span>
      <div class="link-container">
        <a
          class="more-info-link"
          target="_blank"
          href={sliderItems[sliderPosition].cta.link}>
          {sliderItems[sliderPosition].cta.text}
        </a>
      </div>
    </div>
  </div>
</div>
